import { LeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import * as React from 'react';

export interface IProcedureStepBackButtonProps {
  title?: string;
  onBack: () => any;
}

export function ProcedureStepBackButton(props: IProcedureStepBackButtonProps) {
  return (
    <Button block size="large" onClick={props.onBack}>
      <LeftOutlined /> {props.title ?? 'Torna al Modulo'}
    </Button>
  );
}
